import React, { useEffect } from 'react';
import { Button, Card, Flex, notification, Row } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { RouteNames } from '../../router/routeNames';
import LoginForm from './form/LoginForm';
import { Utils } from '../../utils';
import s from '../../pages/auth/form/form.module.scss';

const Login = () => {
  const router = useNavigate();
  const location = useLocation();
  const [api, contextHolder] = notification.useNotification();

  const clickRegistration = () => {
    router(RouteNames.REGISTRATION);
  };
  useEffect(() => {
    const param: any = location.state;
    if (param !== undefined && param !== null) {
      Utils.InfoOpenNotification('topRight', param.param.message, 5, api);
      router(location.pathname, { replace: true });

    }
  }, []);

  return (
    <>
      {contextHolder}
      <div style={{ position: 'absolute', right: 20, top: 30 }}>
        <p style={{ display: 'inline', margin: 10, fontWeight: 600, fontFamily: 'Manrope' }}>Нет аккаунта?</p>
        <Button onClick={clickRegistration} type="primary" style={{ width: 200 }}>Зарегистрироваться</Button>
      </div>
      <Row justify="space-around" align="middle" className={'layout'}>
        <Card className={s.cardform}>
          <Flex justify="center" align="center" vertical>
            <LoginForm clickRegistration={clickRegistration} />
          </Flex>
        </Card>
      </Row>
    </>
  );
};

export default Login;
